import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class MailTemplateService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'MailTemplateService');
  }

  checkDebtorId(id: any) {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/checkDebtor?debtor=' + id;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getTemplate(debtorId): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/getTemplate?dbtrId=' + debtorId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
  saveTemplate(form: object): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/saveTemplate';
    return this.request(serviceUrl, this.setPostParams(form)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getNotification(debtorId, notif): Observable<any> {
    let langId = super.getActiveLang();
    let serviceUrl =
      this.baseUrl +
      this.serviceName +
      '/getNotificationTemplate?dbtrId=' +
      debtorId +
      '&notificationType=' +
      notif +
      '&langId=' +
      langId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
}
